import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  color: ${({ theme }) => theme.colors.dimGray};
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 700;
  height: 85px;
`;

export const NavContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.m};
  ${({ theme }) => theme.spacing.xm};
  ${({ theme }) => theme.spacing.sm};
  height: 85px;
  box-sizing: border-box;
  align-items: flex-end;
`;

export const NavItem = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  height: 49px;
  line-height: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  row-gap: ${({ theme }) => theme.spacing.xxs};
  position: relative;
  z-index: 1;
  width: 54px;
`;

export const CustomNavItem = styled.div``;

export const CustomIconContainer = styled.div``;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
  align-items: center;
`;

export const IconLabel = styled.div(
  ({ theme, active = false }) => css`
    color: ${active ? theme.colors.darkBlue : theme.colors.dimGray};
  `
);
